import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  CURRENCIES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SparePartCondition,
  SparePartSearchSummary,
  SparePartStatus,
  SparePartType,
  SpareProductSize,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}parts/referenceNew`;

export interface SetSparePartRequestNewReferenceArgs {
  sellerId: string;
  manufacturerReference: string;
  manufacturerLabel: string;
  manufacturerId: string;
  supplierReference: string;
  supplierLabel: string;
  supplierId: string;
  sparePartType: SparePartType;
  sparePartStatus: SparePartStatus;
  spareProductSize: SpareProductSize;
  sparePartCondition: SparePartCondition;
  isOriginalEquipmentManufacturer: boolean;
  isCustomerSaleAllowed: boolean;
  preTaxPurchasePriceCurrency: CURRENCIES;
  preTaxPurchasePrice: number;
  stockSite?: string;
}

export const setSparePartRequestNewReference = async ({
  sellerId,
  manufacturerReference,
  manufacturerLabel,
  manufacturerId,
  supplierReference,
  supplierLabel,
  supplierId,
  sparePartType,
  sparePartStatus,
  spareProductSize,
  sparePartCondition,
  isOriginalEquipmentManufacturer,
  isCustomerSaleAllowed,
  preTaxPurchasePriceCurrency,
  preTaxPurchasePrice,
  stockSite,
}: SetSparePartRequestNewReferenceArgs): Promise<
  BackResponse<SparePartSearchSummary> | BackResponseFailure
> => {
  try {
    return await apiCall<BackResponse<SparePartSearchSummary>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        sellerId,
        manufacturerReference,
        manufacturerLabel,
        manufacturerId,
        supplierReference,
        supplierLabel,
        supplierId,
        sparePartType,
        sparePartStatus,
        spareProductSize,
        sparePartCondition,
        isOriginalEquipmentManufacturer,
        isCustomerSaleAllowed,
        preTaxPurchasePriceCurrency,
        preTaxPurchasePrice,
        stockSite,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
